import { Segment } from "semantic-ui-react";

import React from "react";

import ProductionAudiobook from "./ProductionAudiobook";

export default function ProductionArticles() {
	return (
		<Segment padded>
			<ProductionAudiobook tab="articles" />
		</Segment>
	);
}
